import { useContext } from "react";
import { useSelector } from "react-redux";
import { Gantt, Identifiable, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  gantt: Gantt;
  retrieveZoneGantt(zone: Boundaries["retrieveZoneGantt"]["request"]): void;
}

function useRetrieveZoneGantt(zone: Identifiable<Zone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveZoneGanttRequestPending(zone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveZoneGanttRequestSuccess(zone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveZoneGanttRequestFailure(zone),
    ),
    gantt: useSelector(() => selector.getZoneGantt(zone)),
    retrieveZoneGantt: core.retrieveZoneGantt,
  };
}

export { useRetrieveZoneGantt };
